<template>
  <article>
    <div class="filter mt-20">
      <div class="filter__item">
        <el-select class="filter__input" size="mini" v-model="filters.etid" filterable placeholder="请选择">
          <el-option :label="item.title" :value="item.etid" v-for="(item, index) in taskLists" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">标题：</div>
        <el-input v-model="filters.title" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">收件人：</div>
        <el-input v-model="filters.name" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">手机号码：</div>
        <el-input v-model="filters.mobile" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">地址：</div>
        <el-input v-model="filters.address" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="ml-auto">
        <button class="blue-small-btn mr-10" @click="uploadDialog = !uploadDialog">上传</button>
      </div>
    </div>
    <div class="filter mt-10 mb-20">
      <div class="filter__item">
        <div class="filter__name">商品：</div>
        <el-input v-model="filters.goods" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">备注：</div>
        <el-input v-model="filters.remark" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="600">
      <el-table-column prop="ekid" label="ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="etid" label="任务ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="task_title" label="任务名" width="" align="center">
      </el-table-column>
      <el-table-column prop="ordersn" label="订单号" width="" align="center">
      </el-table-column>
      <el-table-column prop="title" label="标题" width="" align="center">
      </el-table-column>
      <el-table-column prop="nickname" label="昵称" width="" align="center">
      </el-table-column>
      <el-table-column prop="name" label="收件人" width="" align="center">
      </el-table-column>
      <el-table-column prop="mobile" label="手机" width="" align="center">
      </el-table-column>
      <el-table-column prop="address" label="地址" width="" align="center">
      </el-table-column>
      <el-table-column prop="pay_amount" label="付款金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="number" label="数量" width="" align="center">
      </el-table-column>
      <el-table-column prop="" label="付款时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.pay_time)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="goods" label="商品信息" width="" align="center">
      </el-table-column>
      <el-table-column prop="remark" label="备注" width="" align="center">
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <!--
      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex jcc">
            <button class="blue-small-btn ml-10" @click="">编辑</button>
          </div>
        </template>
      </el-table-column>
      -->
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
    <el-dialog title="上传快团团订单" :visible.sync="uploadDialog" size="tiny" width="600px" center>
      <div class="flex fdc aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">任务：</div>
            <el-select placeholder="请选择" v-model="uploadInfo.etid">
              <el-option v-for="item in taskLists" :key="item.value" :label="item.title" :value="item.etid"> </el-option>
            </el-select>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">导入数据：</div>
            <el-upload
              ref="kttUpload"
              class="upload-demo"
              drag
              action=""
              :limit="1"
              accept=".xls,.xlsx"
              :on-success="uploadSuccess"
              :on-error="uploadError"
              :http-request="kttOrderUpload"
              >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">只能上传.xls和.xlsx文件</div>
            </el-upload>
          </div>
        </div>
      </div>
    </el-dialog>
  </article>
</template>

<script>
import Clipboard from 'clipboard'
import util from '../../../script/util'
import mixinList from '../../../mixins/list'
import {earnKttOrderLists, downloadAdOrderLists, operLists, taskLists, kttOrderUpload} from '../../../api/api'
export default {
  name: 'kttList',
  mixins: [mixinList],
  data () {
    return {
      statusList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '运行',
          value: 1
        },
        {
          name: '下架',
          value: 0
        },
        {
          name: '完结',
          value: 2
        }
      ],
      lists: [],
      listLoading: false,
      uploadDialog: false,
      operLists: [],
      taskLists: [],
      filters: {
        p: 1,
        l: 20,
        total: 0,
        etid: '',
        title: '',
        name: '',
        mobile: '',
        address: '',
        goods: '',
        remark: ''
      },
      uploadInfo: {
        'etid': ''
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    uploadSuccess (res) {
      // 去掉文件列表
      this.$refs['kttUpload'].clearFiles()
    },
    uploadError (res) {
      // 去掉文件列表
      this.$refs['kttUpload'].clearFiles()
    },
    kttOrderUpload (params) {
      if (this.uploadInfo.etid === '') {
        this.$notify({
          title: '失败',
          message: '请选择任务',
          type: 'error'
        })
        return
      }

      let file = params.file

      // 使用FormData传参数和文件
      let form = new FormData()

      // 添加键值对
      form.append('file', file)

      form.append('etid', this.uploadInfo.etid)

      kttOrderUpload(form).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
          this.uploadInfo.etid = ''
          this.uploadDialog = false
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    getOperLists () {
      let params = {
        market: 3,
        status: 1,
        l: 500,
        p: 1
      }
      operLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          data.d.lists.map((item, index) => {
            if ([1, 4, 5].includes(item['opid'])) {
              this.operLists.push(
                {
                  nickname: item.nickname,
                  opid: item.opid
                }
              )
            }
          })
          this.operLists.unshift({
            nickname: '所有',
            opid: ''
          })
        }
      })
    },
    getTaskLists () {
      let params = {
        l: 500,
        p: 1
      }
      taskLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.taskLists = data.d.lists.map((item, index) => {
            return {
              title: item.title + '(' + item.etid + ')',
              etid: item.etid
            }
          })
          this.taskLists.unshift({
            title: '所有',
            etid: ''
          })
        }
      })
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }

      if (filters.etid !== '') {
        params.etid = filters.etid
      }

      if (filters.title !== '') {
        params.title = filters.title
      }

      if (filters.name !== '') {
        params.name = filters.name
      }

      if (filters.mobile !== '') {
        params.mobile = filters.mobile
      }

      if (filters.address !== '') {
        params.address = filters.address
      }

      if (filters.goods !== '') {
        params.goods = filters.goods
      }

      if (filters.remark !== '') {
        params.remark = filters.remark
      }

      this.listLoading = true
      earnKttOrderLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.notifyError('服务器出错了')
      })
    },
    download (etid) {
      let link = downloadAdOrderLists + '?choose=' + 4
      link = link + '&etid=' + etid
      window.open(link, 'a')
    },
    copyLink () {
      let clipboard = new Clipboard('.copy-btn')
      clipboard.on('success', e => {
        this.$notify({
          title: '成功',
          message: '复制成功',
          type: 'success'
        })

        // 释放内存
        clipboard.destroy()
      })

      clipboard.on('error', e => {
        this.$notify({
          title: '失败',
          message: '复制失败',
          type: 'error'
        })

        // 释放内存
        clipboard.destroy()
      })
    },
    filterParamsChange () {
      this.filters.p = 1
      this.getList()
    }
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.etid': 'filterParamsChange',
    'filters.title': 'filterParamsChange',
    'filters.name': 'filterParamsChange',
    'filters.mobile': 'filterParamsChange',
    'filters.address': 'filterParamsChange',
    'filters.goods': 'filterParamsChange',
    'filters.remark': 'filterParamsChange'
  },
  mounted () {
    this.getOperLists()
    this.getList()
    util.setCookie('createAddetail', '')
    this.getTaskLists()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/module/earn/kttList.vue